import React, { type Key, type ReactElement } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import { repeat } from 'src/common/helpers/RepeatHelper';

type FixedSizeArray<N extends number, T = unknown> = T[] & { length: N };

type SkeletonRowProps<N extends number = number> = {
	count: N;
	height: string;
	width: string;
	animationSpeed: number;
	keySet: FixedSizeArray<N, Key>;
};

export const FilterRows = <N extends number>({
	count,
	height,
	width,
	animationSpeed,
	keySet
}: SkeletonRowProps<N>): ReactElement => (
	<>
		{repeat(count).map((_, i) => (
			<div key={keySet[i]} className="skeleton-filters-item">
				<EvSkeleton height={height} width={width} animationSpeed={animationSpeed} />
			</div>
		))}
	</>
);
